import {useRef, useState} from 'react'
import {SBack, SLowcodeList, STitle} from 'shj-components'
import config from './config'
import {Button, Col, Flex, message, Row, Spin, Tag, Tooltip} from 'antd'
import FormComponent from './form'
import {apiData2Table} from '@/utils/data.ts'
import {clueImportPage, clueImportUpload} from '@/services/customerServices'
import styles from './form.module.less'
import {fileDownload} from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'

const ClueImport = () => {
  const listRef = useRef<any>()
  const [loading, setLoading] = useState(false)
  const fetchList = (values: any) => {
    return new Promise((resolve, reject) => {
      try {
        const {current, pageSize} = values
        clueImportPage({
          current,
          pageSize,
        }).then((resp: any) => {
          resolve(apiData2Table(resp))
        })
      } catch {
        reject({success: false})
      }
    })
  }
  //下载导入模板
  const downloadImportTemp = async () => {
    setLoading(true)
    message.loading('下载中，请稍后', 0)
    fileDownload(UrlConfig.PlusClueWeb.ExportTemplate)
        .then(() => {
          setLoading(false)
          message.destroy()
        })
        .catch(() => {
          setLoading(false)
          message.destroy()
        })
  }

  const customUpload = (values: any) => {
    const obj = {
      accountId: values?.accountId,
      chargeFlag: values?.chargeFlag,
      formData: values?.formData,
    }
    message.loading('导入中，请稍后', 0)
    clueImportUpload(obj)
        .then((res: any) => {
          const {errorCode, message: msg} = res
          message.destroy()
          if (errorCode == 0 || errorCode == '0') {
            message.success(msg || '操作成功')
            listRef.current.reset()
          } else {
            message.error(msg || '操作失败')
          }
        })
        .catch(err => {
          message.destroy()
          message.error(err.message || '操作失败')
        })
  }

  const extension = {
    request: {fetchList},
    events: {downloadImportTemp},
    customRender: {
      nameRender(v, record) {
        return <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start'}}>
          <Tag bordered={false}
               style={{
                 backgroundColor: record.status === 'FAILED' ? '#FFEAE8' : '#D7F7EA',
                 color: record.status === 'FAILED' ? '#EB3723' : '#00A865'
               }}>{record.statusName}</Tag>
          <Tooltip title={v}>
            <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{v}</div>
          </Tooltip>
        </div>
      }
    }
  }
  return (
      <div>
        <Spin spinning={loading} tip={'模板下载中...'}>
          <Flex align={'stretch'}>
            <div style={{width: '35%', background: 'white', padding: 15, marginRight: 10}}>
              <STitle title={'线索导入'} style={{marginBottom: 15}}/>
              <FormComponent customUpload={customUpload}/>
              <a style={{position: "relative", top: -10}} onClick={downloadImportTemp}>下载导入模板</a>
            </div>
            <div style={{background: 'white', width: '65%', height: 'calc(100vh - 120px)'}}>
              <div style={{padding: '15px 0 0 15px'}}>
                <STitle title={'导入历史'} style={{marginBottom: 15}}/>
              </div>
              <SLowcodeList config={config} ref={listRef} {...extension} />
            </div>
          </Flex>
        </Spin>
      </div>
  )
}

export default ClueImport
